'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';

declare global {
  interface Window {
    ym?: (id: number, type: string, url?: string) => void;
  }
}

export default function YandexMetrika() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (typeof window.ym !== 'function') return;
    
    const url = `${pathname}?${searchParams}`;
    window.ym(105556819, 'hit', url);
  }, [pathname, searchParams]);

  return null;
}
